import React, { useState } from 'react';
import { Grid, Text } from 'elements';
import { showAlert } from 'components/modal/showConfirm';
import { Input, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { TextArea } = Input;

type TEdit = {
  initBody?: string;
  onSave?: (args1: string) => void;
};

const Edit = ({ initBody, onSave }: TEdit) => {
  const [body, setBody] = useState(initBody || '');

  const save = () => {
    if (!body) return showAlert(undefined, '댓글 입력', '내용을 입력해주세요.');
    setBody('');
    if (onSave) onSave(body);
  };

  return (
    <>
      <Grid gap='8px' align='center'>
        <CheckOutlined />
        <Text>댓글 쓰기</Text>
      </Grid>
      <Grid gap='20px' marginTop='20px' justify='space-between' md={{ justify: 'flex-end' }}>
        <Grid isInline width='calc(100% - 140px)' md={{ width: '100%' }}>
          <TextArea
            rows={3}
            placeholder='내용을 입력해주세요.'
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </Grid>
        <Button onClick={save}>등록</Button>
      </Grid>
    </>
  );
};

export default Edit;
